import { LogLevel, PublicClientApplication } from '@azure/msal-browser'

import { getEnvs } from '../utils/env'

const { frontendAppClientId, tenantId } = getEnvs()

const msalConfig = {
  auth: {
    clientId: frontendAppClientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${window.location.origin}/sign-in`,
  },
  cache: {
    cacheLocation: 'localStorage', // localStorage in order to allow SSO between multiple tabs
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ): void => {
        if (containsPii) {
          // do not log personal identifiable information
          return
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console
            console.error(message)
            return
          case LogLevel.Info:
            // eslint-disable-next-line no-console
            console.info(message)
            return
          case LogLevel.Warning:
            // eslint-disable-next-line no-console
            console.warn(message)
            return
          default:
            // eslint-disable-next-line no-console
            console.debug(message)
        }
      },
      piiLoggingEnabled: false,
    },
  },
}

const msalInstance = new PublicClientApplication(msalConfig)

async function initializeMsal() {
  await msalInstance.initialize()
}
initializeMsal()

export { msalConfig, msalInstance }
